import React from 'react';
import { Box, Container, Typography, useMediaQuery, useTheme } from '@mui/material';

const Footer = () => {
  const themeInstance = useTheme();
  const isMobile = useMediaQuery(themeInstance.breakpoints.down('sm'));
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        position: "fixed",
        bottom: 0,
        width: "100%",
        backgroundColor: "background.paper",
        borderTop: "1px solid rgba(255,255,255,0.1)",
        py: { xs: 2, sm: 2.5 },
        zIndex: 10,
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography
            variant="body2"
            color="text.secondary"
            align="center"
          >
            © {currentYear} Dynamix-AI.com. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer; 